import React, { ReactNode, forwardRef } from 'react';
import { styled } from '@mui/material/styles';

interface GridProps {
  columns?: string;
  columnGap?: string;
  rowGap?: string;
  padding?: number;
  px?: number;
  py?: number;
}

const Grid = styled('div')<GridProps>(
  ({ theme, columns = '1fr auto', columnGap = '16px', rowGap = '0', padding = 2, px, py }) => ({
    display: 'grid',
    gridTemplateColumns: columns,
    alignItems: 'center',
    paddingTop: theme.spacing(py ?? padding),
    paddingBottom: theme.spacing(py ?? padding),
    paddingLeft: theme.spacing(px ?? padding),
    paddingRight: theme.spacing(px ?? padding),
    columnGap,
    rowGap,
  }),
);

export interface GridComponentProps {
  columns?: string;
  columnGap?: string;
  rowGap?: string;
  padding?: number;
  px?: number;
  py?: number;
  children: ReactNode;
  style?: React.CSSProperties;
}

export const GridComponent = forwardRef<HTMLDivElement, GridComponentProps>(
  ({ columns, columnGap, rowGap, padding, px, py, children, style }, ref) => {
    return (
      <Grid
        ref={ref}
        columns={columns}
        columnGap={columnGap}
        rowGap={rowGap}
        padding={padding}
        px={px}
        py={py}
        style={style}
      >
        {children}
      </Grid>
    );
  },
);

GridComponent.displayName = 'GridComponent';
